import { axios } from 'configs';

export type TDifyKnowledgeDocument = {
  id: string;
  name: string;
  createdAt: string | null;
  indexingStatus: string | null;
};

export type TDifyKnowledgeListResponse = {
  data: TDifyKnowledgeDocument[];
  total: number;
  page: number;
  limit: number;
};

export const listDifyKnowledgeDocuments = async (params?: {
  page?: number;
  limit?: number;
}): Promise<TDifyKnowledgeListResponse> => {
  const response = await axios.get<TDifyKnowledgeListResponse>(
    'dify-knowledge/documents',
    { params },
  );
  return response.data;
};

export const createDifyKnowledgeDocument = async (body: {
  name: string;
  text: string;
}): Promise<{ id: string; name: string }> => {
  const response = await axios.post<{ id: string; name: string }>(
    'dify-knowledge/documents',
    body,
  );
  return response.data;
};

export type TDifyKnowledgeDocumentDetail = TDifyKnowledgeDocument & {
  text: string;
};

export const getDifyKnowledgeDocument = async (
  documentId: string,
): Promise<TDifyKnowledgeDocumentDetail> => {
  const response = await axios.get<TDifyKnowledgeDocumentDetail>(
    `dify-knowledge/documents/${documentId}`,
  );

  return response.data;
};

export const updateDifyKnowledgeDocument = async (
  documentId: string,
  body: { name: string; text: string },
): Promise<{ id: string; name: string }> => {
  const response = await axios.patch<{ id: string; name: string }>(
    `dify-knowledge/documents/${documentId}`,
    body,
  );

  return response.data;
};

export const deleteDifyKnowledgeDocument = async (
  documentId: string,
): Promise<void> => {
  await axios.delete(`dify-knowledge/documents/${documentId}`);
};
